import React from 'react';
import { connect } from 'react-redux';
import classes from './MealsSelect.scss';
import Checkbox from '../../../UI/CommonCheckBox/CommonCheckBox';

import * as farePriceActions from '../../../../store/actions/index';

const mealsSelect = (props) => {
    let mealsViewO = props.mealsViewO;
    let mealsViewR = props.mealsViewR;
    let mealsView = null;
    let rph = null;
    let uid = null;
    let tripType = null;
    let selectedMeal = {};
    if (props.flow === 'O') {
        mealsViewO = props.meals.O[mealsViewO].mealOptions;
        rph = props.meals.O[props.mealsViewO].rph;
        uid = props.meals.O[props.mealsViewO].uid;
        mealsView = mealsViewO;
        tripType = props.flow;
        if(Object.keys(props.selectedMeals.O).length !== 0) {
            selectedMeal = props.selectedMeals.O[props.mealsViewO];
        }
    } else {
        mealsViewR = props.meals.R[mealsViewR].mealOptions;
        rph = props.meals.R[props.mealsViewR].rph;
        uid = props.meals.R[props.mealsViewR].uid;
        mealsView = mealsViewR;
        tripType = props.flow;
        if(Object.keys(props.selectedMeals.R).length !== 0) {
            selectedMeal = props.selectedMeals.R[props.mealsViewR];
        }
    }

    return (
        <ul className={classes.List}>
            {mealsView.map(meal => {
                    return <li className={[classes.ListItem, selectedMeal ? selectedMeal.typ === meal.typ ? classes.ListItemActive : null : null].join(' ')} key={meal.typ} onClick={props.passengers.length === 1 ? 
                        () => {
                            if(selectedMeal.desc === meal.desc) {
                                props.onSaveMeal(meal, rph, uid, tripType);
                                props.onDeselctMeal(props.passengers[0].paxID, props.flow);
                                props.onRemoveAddon("Meals", parseInt(meal.amt, 10), props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex, props.flow === 'O' ? 'O' : 'R');
                            } else {
                                props.onRemoveAddon("Meals", parseInt(selectedMeal.amt, 10), props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex, props.flow === 'O' ? 'O' : 'R');
                                props.onSaveMeal(meal, rph, uid, tripType);
                                props.onSelectMeal(props.passengers[0].paxID, props.flow, props.passengers[0].ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].desc === selectedMeal.desc);
                                meal.amt !== '0' ? props.onAddAddon({addonLabel: "Meals", amount: parseInt(meal.amt, 10), legIndex: props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex, leg: props.flow === 'O' ? 'O' : 'R'}) : console.log("Amount greater that zero");
                            }
                        } :
                        () => {
                            props.onSaveMeal(meal, rph, uid, tripType);
                            props.onShowPax();
                        }}>
                        <div className={`u-flex`}>
                            <div className={`u-flex align-items-start f-column justify-content-center`}>
                                <p className={`u-fontSize13 u-textColorDark u-fontWeightMedium`}>{meal.desc}</p>
                                { meal.amt === '0' ? null : <span className={`u-fontSize13 u-textColorLight`}>&#8377; {meal.amt}</span> }
                            </div>
                        </div>
                        {props.passengers.length === 1 ? (
                            <Checkbox 
                                type="ssr" 
                                readOnly 
                                checked={selectedMeal ? selectedMeal.typ === meal.typ && props.passengers[0].ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].desc !== "" ? true : false : false}
                                />
                        ) : (
                            <Checkbox 
                                type="ssr" 
                                readOnly 
                                checked={selectedMeal ? selectedMeal.typ === meal.typ ? true : false : false}
                                />
                        )}
                    </li>
                })}
        </ul>
    );
}

const mapStateToProps = state => {
    return {
        passengers: state.farePrice.passengers,
        mealsViewOIndex: state.farePrice.mealsViewOneWayVal,
        mealsViewRIndex: state.farePrice.mealsViewReturnVal,
        selectedMeals: state.farePrice.selectedMeals
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSaveMeal: (meal, rph, uid, tripType) => dispatch(farePriceActions.saveMeal(meal, rph, uid, tripType)),
        onSelectMeal: (id, flow, isUpdate) => dispatch(farePriceActions.selectMeal(id, flow, isUpdate)),
        onDeselctMeal: (id, flow) => dispatch(farePriceActions.deselectMeal(id, flow)),
        onShowPax: () => dispatch(farePriceActions.showPax()),
        onAddAddon: (addon) => dispatch(farePriceActions.addAddon(addon)),
        onRemoveAddon: (label, amount, legIndex, leg) => dispatch(farePriceActions.removeAddon(label, amount, legIndex, leg))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(mealsSelect);


// WEBPACK FOOTER //
// ./src/components/Addons/Meals/MealsSelect/MealsSelect.js